<template>
  <div class="form-container ou-donation-form">
      <div class="holder">
          <PaymentForm class="form-horizontal">
              <FormSection title="Your Donation">
                  <FormRow inline>
                    <LazyCurrencySelector :currencies="['USD', 'ILS']"/>
                  </FormRow>
                  <FormRow> 
                    <OuisraelZecherLmachatzitHashekelAmounts/>                    
                    <ErrorLabel field="amount" />
                  </FormRow>
              </FormSection>
              <FormSection title="Personal Information">
                  <FormRow inline>
                      <FormCol field="title" :flex="1"/>
                      <FormCol field="firstName" :flex="2" />
                      <FormCol field="lastName" :flex="2" />
                  </FormRow>
                  <FormRow inline>
                      <FormCol field="email" />
                      <FormCol field="phone" />
                  </FormRow>
                  <FormRow inline>
                      <Consent privacy="https://www.ouisrael.org/privacy-policy/"/>
                  </FormRow>                   
              </FormSection>
              <FormSection title="Address" last>
                  <DonorAddress/>
              </FormSection>
              <FormSection title="Payment Info" last>
                  <FormRow>
                    <Receipt />
                  </FormRow>
                    <FormRow inline>
                        <FormCol field="card" :showLabel="false"/>
                    </FormRow>
                </FormSection>
              <PaymentButton showAmount btnText="Donate"/>
          </PaymentForm>
      </div>
  </div>
</template>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
.other-means {
  font-size: 14px;
  line-height: 1.6;
}
</style>

